import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AttributeManipulationGroupsApiService {

  constructor(private http: HttpClient) {}

  readonly groupsUrl: string = 'normalization/group';
  readonly groupsTestUrl: string = 'normalization/group/test';

  getAttributeManipulationGroups(): Observable<any> {
    return this.http.get(this.groupsUrl);
  }

  getAttributeManipulationGroup(attributeManipulationGroupId): Observable<any> {
    return this.http.get(`${this.groupsUrl}/${attributeManipulationGroupId}`);
  }

  addAttributeManipulationGroup(attributeManipulationGroup): Observable<any> {
    return this.http.post(this.groupsUrl, attributeManipulationGroup);
  }

  editAttributeManipulationGroup(attributeManipulationGroup, attributeManipulationGroupId): Observable<any> {
    return this.http.put(`${this.groupsUrl}/${attributeManipulationGroupId}`, attributeManipulationGroup);
  }

  deleteAttributeManipulationGroup(attributeManipulationGroupId): Observable<any> {
    return this.http.delete(`${this.groupsUrl}/${attributeManipulationGroupId}`);
  }

  testAttributeManipulationGroup(testRequest): Observable<any> {
    return this.http.post(this.groupsTestUrl, testRequest);
  }
}
